import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0deg)' })),
      state('open', style({ transform: 'rotate(180deg)' })),
      transition('open => default', animate('500ms ease-out')),
      transition('default => open', animate('500ms ease-in'))
  ])
]
})
export class AccordionComponent {

  faSortDown = faSortDown

  /**
   * The reference to the accordion div, which is used to calculate the content height.
   */
  @ViewChild('accordion') accordion: ElementRef<HTMLDivElement>

  @Input() title?: string
  @Input() primary: boolean = true
  @Input() dark: boolean = false

  @HostBinding("style.--height") height = "0px"
  @HostBinding("style.--labelSize") @Input() labelSize: string = "12px";

  open: boolean = false
  state: string = "default"

  constructor() { }

  /**
   * Opens and closes the accordion by changing the height and rotating the dropdown icon.
   */
  changeAccordionState() {
    if (this.open) {
      this.state = "default"
      this.height = "0px"
      this.open = false
    } else {
      this.state = "open"
      this.height = this.accordion!.nativeElement.scrollHeight + "px"
      this.open = true
    }
  }

}
